import { ItemData } from 'core/models/Template'

export const GRADES_CATALOG_TYPE = 'grades' as const

export const GRADES_CATALOG_CONFIG = {
    type: GRADES_CATALOG_TYPE,
    fixedHeader: true,
    isExistRightToolbar: false,
    treeView: false,
} as const

export type GradesSelectedItems = ItemData[]
